<template>
  <div v-if="filters && filters.length > 0" class="is-flex" :key="dummy">
    <multiple-filter v-for="filter in filters" :key="filter.designator" :payload="filter"></multiple-filter>
  </div>
</template>
<script>
import MultipleFilter from '@/components/FilterMultiple'
export default {
  name: 'multiple-filters',
  data () {
    return {
      dummy: 0
    }
  },
  components: {
    MultipleFilter
  },
  props: {
    filters: {
      type: Array
    }
  },
  watch: {
    filters: {
      handler: function () {
        this.dummy += 1
      },
      deep: true
    }
  }
}
</script>
